export default __webpack_public_path__ + "static/media/deativated_status_icon.288eac05.svg";